module.exports = __webpack_public_path__ + "img/MM-12.15-md.53c3b20a.jpg";